import { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "@/config/firebase";
import { useAuthStore } from "@/store/authStore";
import type { CloudAccount, CloudProviderId } from "@/services/cloudAccountsService";

/**
 * Live map of the user's connected cloud accounts
 * (users/{uid}/cloudAccounts, written by the export-worker).
 */
export function useCloudAccounts(): {
  accounts: Map<CloudProviderId, CloudAccount>;
  loading: boolean;
} {
  const { user } = useAuthStore();
  const [accounts, setAccounts] = useState<Map<CloudProviderId, CloudAccount>>(new Map());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.uid) {
      setAccounts(new Map());
      setLoading(false);
      return;
    }
    const unsubscribe = onSnapshot(
      collection(db, `users/${user.uid}/cloudAccounts`),
      (snapshot) => {
        const map = new Map<CloudProviderId, CloudAccount>();
        snapshot.docs.forEach((docSnap) => {
          map.set(docSnap.id as CloudProviderId, docSnap.data() as CloudAccount);
        });
        setAccounts(map);
        setLoading(false);
      },
      () => setLoading(false)
    );
    return () => unsubscribe();
  }, [user?.uid]);

  return { accounts, loading };
}
